module.exports = __webpack_public_path__ + "static/media/appmobile5.593eabdc.webp";